import React from 'react'
import { HiOutlineUsers } from 'react-icons/hi'
import { GrAppsRounded } from 'react-icons/gr'
import { RiUserSettingsLine, RiCoupon2Fill } from 'react-icons/ri'
import { LiaUserShieldSolid } from 'react-icons/lia'
import {  FaShieldAlt } from 'react-icons/fa'
import { TbCrown } from 'react-icons/tb'
import { MdOutlineScreenSearchDesktop, MdNotificationsActive, MdSystemUpdateAlt } from 'react-icons/md'
import { BiTransfer, BiLineChart } from 'react-icons/bi'
import { AiOutlineAudit, AiOutlineReconciliation } from 'react-icons/ai'
// import { BsDatabaseCheck } from 'react-icons/bs'

// A1 — Full 13-module sidebar. Items map 1:1 with the RBAC matrix in
// `assets/data/PermissionList.json`; `module` field is what
// `useAuth.checkPermission(module, action)` reads.
//
// Modules with no backend yet show a "Coming soon" disabled state via
// `disabled: true` (the Sidebar component reads this flag — see follow-up
// A1.1 if it isn't honoured yet).
const menuItems = [
    { id: 0, label: 'Dashboard', module: 'dashboard', link: '/', icon: <GrAppsRounded size={20} /> },
    { id: 1, label: 'Roles', module: 'roles', link: '/roles', icon: <RiUserSettingsLine size={20} /> },
    {
        id: 2,
        label: 'Assign Permissions',
        module: 'assign-permissions',
        link: '/assign-permissions',
        icon: <LiaUserShieldSolid size={20} />,
    },
    {
        id: 3, label: 'User Management', module: 'users', icon: <HiOutlineUsers size={20} />, children: [
            { id: 31, label: 'Weallat Users', module: 'users', link: '/users' },
            { id: 32, label: 'Live Users', module: 'users', link: '/live-users' },
            { id: 33, label: 'Beta Invites', module: 'users', link: '/beta-invites' },
        ],
    },
    {
        id: 4, label: 'Transactions', module: 'transactions', icon: <BiTransfer size={20} />, children: [
            // { id: 41, label: 'Order History', module: 'transactions', link: '/history' },
            { id: 42, label: 'Incomplete Orders', module: 'transactions', link: '/transactions/incomplete' },
            { id: 43, label: 'Drop-off Funnel', module: 'transactions', link: '/transactions/funnel' },
            { id: 44, label: 'Stuck Orders', module: 'transactions', link: '/transactions/stuck' },
            { id: 45, label: 'Dipository', module: 'transactions', link: '/transactions/dipository' },
        ],
    },
    {
        id: 5, label: 'SIP Management', module: 'sip', icon: <BiLineChart size={20} />, children: [
            { id: 51, label: 'Active SIPs', module: 'sip', link: '/sip' },
            { id: 52, label: 'Incomplete SIPs', module: 'sip', link: '/sip/incomplete' },
        ],
    },
    // Market Intelligence — Insights UI. Sub-items match the four primary
    // pages of the mockup (Screeners, Results, Datasets, Refresh status).
    {
        id: 6,
        label: 'Market Intelligence',
        module: 'screener',
        icon: <MdOutlineScreenSearchDesktop size={20} />,
        children: [
            { id: 61, label: 'Screeners', module: 'screener', link: '/screener' },
            { id: 62, label: 'Results', module: 'screener', link: '/screener/results' },
            { id: 63, label: 'Datasets', module: 'screener', link: '/screener/datasets' },
            { id: 64, label: 'Refresh Status', module: 'screener', link: '/screener/status' },
        ],
    },
    {
        id: 7, label: 'Subscriptions', module: 'subscriptions', icon: <TbCrown size={20} />, children: [
            { id: 71, label: 'Active Subscriptions', module: 'subscriptions', link: '/subscriptions/active' },
            { id: 72, label: 'Incomplete Payments', module: 'subscriptions', link: '/subscriptions/incomplete' },
            { id: 73, label: 'Revenue Dashboard', module: 'subscriptions', link: '/subscriptions/revenue' },
            { id: 74, label: 'Expiring Soon', module: 'subscriptions', link: '/subscriptions/expiring' },
            { id: 75, label: 'Churned', module: 'subscriptions', link: '/subscriptions/churned' },
            { id: 76, label: 'Payment Orders', module: 'payments', link: '/payments/orders' },
            { id: 77, label: 'Mandates', module: 'payments', link: '/payments/mandates' },
        ],
    },
    { id: 9, label: 'Plans', module: 'plans', link: '/plans', icon: <TbCrown size={20} /> },
    { id: 10, label: 'Promo Codes', module: 'coupons', link: '/coupons', icon: <RiCoupon2Fill size={20} /> },
    {
        id: 11, label: 'Notifications', module: 'notifications', icon: <MdNotificationsActive size={20} />, children: [
            { id: 111, label: 'Delivery Stats', module: 'notifications', link: '/notifications/stats' },
            { id: 112, label: 'Templates', module: 'notifications', link: '/notifications/templates' },
            { id: 113, label: 'Broadcast', module: 'notifications', link: '/notifications/broadcast' },
        ],
    },
   
    { id: 13, label: 'Reconciliation', module: 'reconciliation', link: '/reconciliation', icon: <AiOutlineReconciliation size={20} /> },
    {
        id: 14, label: 'Risk Management', module: 'risk', icon: <FaShieldAlt size={20} />, children: [
            { id: 141, label: 'Questionnaires', module: 'questionnaires', link: '/questionnaires' },
            { id: 142, label: 'Questions', module: 'questions', link: '/questions' },
            { id: 144, label: 'Category', module: 'category', link: '/risk-category' },
        ],
    },
    {
        id: 15, label: 'Audit & Logs', module: 'audit', icon: <AiOutlineAudit size={20} />, children: [
            // A9 partial-ship — webhook + gateway log inspectors live now.
            // { id: 151, label: 'Webhook Logs', module: 'audit', link: '/audit/webhooks' },
            // { id: 152, label: 'Gateway Logs', module: 'audit', link: '/audit/gateway' },
            // // Part D3 — Activity Log now backed by /api/v1/users/admin-activity/ in identity svc.
            // // Centralized cross-service audit still deferred (BACKEND-FIX-17/18).
            // { id: 153, label: 'Activity Log', module: 'audit', link: '/audit/activity' },
            { id: 154, label: 'Integrity Results', module: 'audit', link: '/integrity-results' },
        ],
    },
    { id: 16, label: 'App Versions', module: 'app-versions', link: '/app-versions', icon: <MdSystemUpdateAlt size={20} /> },
]

export default menuItems
